<script lang="ts">
    import { Router, Route, links } from "svelte-routing"
    import { scrollToTop } from "svelte-scrollto"
    import { location } from "../store"
    import Header from "./Header.svelte"
    import Footer from "./Footer.svelte"

    export let url = ""
    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            push: false,
            pop: false,
        }
    }

    // scroll to top on new site
    location.subscribe((l) => {
        if (l.push) scrollToTop()
    })

    if (typeof window !== "undefined") console.log("App initialized")

    import Seite from "./Seite.svelte"
    import Start from "./Start.svelte"
    import Fehler404 from "./Fehler404.svelte"
    import Favicon from "./Favicon.svelte"
</script>

<svelte:head>
    <Favicon />
</svelte:head>

<div use:links>
    <!-- Header -->
    <Header />

    <div id="sitewrapper" data-url="{url}">
        <Router url="{url}">
            <Route path="/">
                <Start />
            </Route>

            <Route path="/en">
                <Start />
            </Route>

            <Route path="/preview">
                <Seite pfad="" preview />
            </Route>

            <Route path="/*pfad" let:params>
                <Seite pfad="{params.pfad}" />
            </Route>

            <Route>
                <Fehler404 />
            </Route>
        </Router>
    </div>
    <Footer />
</div>

<style lang="less" global>
    @import "../css/main.less";

    #sitewrapper {
        position: relative;
        padding-top: 120px;
        @media (max-width: 1270px) {
            padding-top: 80px;
        }
    }
    .sliderholder {
        max-width: 1600px;
        margin-left: auto;
        margin-right: auto;
    }

    .collection :global {
        .flex();
        margin: -15px;
        flex-wrap: wrap;
        .post {
            padding: 15px;
            .flex();
            flex-direction: column;
            .item {
                flex-grow: 1;
            }
        }
    }

    h1 {
        font-size: 2rem;
        font-weight: 400;
        @media (max-width: 768px) {
            font-size: 1.6rem;
        }
        &:before {
            content: "";
            height: 100%;
            background: #ba2c2b;
            border-left: solid 4px #ba2c2b;
            margin-right: 20px;
        }
    }
</style>
